@if (Variant === 'bare') {
  <div class="agu-drop agu-drop--bare" [class.agu-drop--over]="DragOver" (dragover)="OnDragOver($event)" (dragleave)="OnDragLeave()" (drop)="OnDrop($event)">
    <span class="agu-drop__title">{{ Title }}</span>
    @if (Hint) { <span class="agu-drop__hint">{{ Hint }}</span> }
    @if (Note) { <span class="agu-drop__note" [id]="NoteID">{{ Note }}</span> }
    <ng-content />
    <button type="button" class="agu-drop__button" [attr.aria-disabled]="Disabled ? 'true' : null" [attr.aria-busy]="Busy"
            [attr.aria-describedby]="Note ? NoteID : null" (click)="Open()">{{ ButtonLabel }}</button>
  </div>
} @else {
<button type="button" class="agu-drop" [class.agu-drop--over]="DragOver" [attr.aria-disabled]="Disabled ? 'true' : null" [attr.aria-busy]="Busy"
        [attr.aria-describedby]="Note ? NoteID : null"
        (click)="Open()" (dragover)="OnDragOver($event)" (dragleave)="OnDragLeave()" (drop)="OnDrop($event)">
  <span class="agu-drop__title">{{ Title }}</span>
  @if (Note) { <span class="agu-drop__note" [id]="NoteID">{{ Note }}</span> }
  @if (Hint) { <span class="agu-drop__hint">{{ Hint }}</span> }
  <span class="agu-drop__button">{{ ButtonLabel }}</span>
</button>
}
<input #picker class="agu-drop__input" type="file" [attr.accept]="AcceptAttr || null" tabindex="-1" aria-hidden="true" (change)="OnPick($event)" />